import LoadingButton, { LoadingButtonProps } from '@mui/lab/LoadingButton';
import { forwardRef } from 'react';

export const Button = forwardRef<HTMLButtonElement, LoadingButtonProps>(
  function Forwarded(props, ref) {
    return <LoadingButton {...props} ref={ref} />;
  }
) as typeof LoadingButton;
